import { SignatureBoxContext } from "features/documents/components/SignatureBox/context/SignatureBoxContext";
import { useContext } from "react";

export const useSignatureBox = () => {
  return useContext(SignatureBoxContext);
};
